<template>
  <footer class="pt-4 mt-5">
    <section class="our-reach pt-3 pb-3">
      <!-- FooterTopCarousel -->
      <FooterTopCarousel
        >We strive to deliver absolute delight</FooterTopCarousel
      >
      <!-- FooterTopCarousel -->
    </section>

    <section class="partners pt-3 pb-3">
      <!-- Partners -->
      <PartnerCarousel>Our Partners</PartnerCarousel>
      <!-- End Partners -->
    </section>

    <section class="footer pb-3">
      <!-- Footer Content -->
      <div class="container-fluid pt-5 px-3">
        <div class="row text-center">
          <div class="col-xs-6 col-sm-4 col-md">
            <div class="footers-logo" style="margin-top:-20px">
              <img
                class="img-fluid"
                src="/assets/images/brand1.png"
                width="200px"
                id="brand-logo"
              />
            </div>
            <div class>
              <p>
                <a href="mailto::hello@quickleapglobal.com"
                  >hello@quickleapglobal.com</a
                >
              </p>
              <p>
                <a href="mailto::+234 (0) 813 486 0483"
                  >+234 (0) 813 486 0483</a
                >
              </p>
            </div>
            <div class="social-icons row justify-content-center">
              <div class="col-10">
                <div class="row mb-2">
                  <div class="col col-md-4">
                    <a href="https://www.facebook.com/">
                      <font-awesome-icon
                        :icon="['fab', 'facebook']"
                        size="2x"
                      />
                    </a>
                  </div>
                  <div class="col col-md-4">
                    <a href="https://www.instagram.com/">
                      <font-awesome-icon
                        :icon="['fab', 'instagram']"
                        size="2x"
                      />
                    </a>
                  </div>
                  <div class="col col-md-4">
                    <a href="https://www.facebook.com/">
                      <font-awesome-icon :icon="['fab', 'youtube']" size="2x" />
                    </a>
                  </div>
                  <div class="col col-md-4">
                    <a href="https://twitter.com/">
                      <font-awesome-icon :icon="['fab', 'twitter']" size="2x" />
                    </a>
                  </div>
                  <div class="col col-md-4">
                    <a href="https://plus.google.com/">
                      <font-awesome-icon
                        :icon="['fab', 'google-plus-g']"
                        size="2x"
                      />
                    </a>
                  </div>
                  <div class="col col-md-4">
                    <a href="https://plus.google.com/">
                      <font-awesome-icon
                        :icon="['fab', 'linkedin-in']"
                        size="2x"
                      />
                    </a>
                  </div>
                  <div class="col col-md-4">
                    <a href="#">
                      <font-awesome-icon
                        :icon="['fab', 'snapchat-ghost']"
                        size="2x"
                      />
                    </a>
                  </div>
                  <div class="col col-md-4">
                    <a href="#">
                      <font-awesome-icon
                        :icon="['fab', 'whatsapp']"
                        size="2x"
                      />
                    </a>
                  </div>
                  <div class="col col-md-4">
                    <a href="#">
                      <font-awesome-icon
                        :icon="['fab', 'pinterest-p']"
                        size="2x"
                      />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-6 col-sm-4 col-md">
            <h5>Navigation</h5>
            <ul class="list-unstyled">
              <li>
                <router-link to="/about">About Us</router-link>
              </li>
              <li>
                <router-link to="/marketplace">MarketPlace</router-link>
              </li>
              <!-- <li>
                 <router-link to="javascript:void(0)">Sponsor Trade</router-link>
              </li>-->
              <li>
                <router-link to="/inventory">Inventory manager</router-link>
              </li>
              <li>
                <router-link to="/marketdata">Market Data</router-link>
              </li>
              <li>
                <router-link to="/legal">Terms of use</router-link>
              </li>
              <li>
                <router-link to="/legal">Privacy Policy</router-link>
              </li>
              <li>
                <router-link to="/legal">Legal</router-link>
              </li>
              <li>
                <router-link to="javascript:void(0)"
                  >Term and condition of sale</router-link
                >
              </li>
            </ul>
          </div>
          <div class="col-6 col-sm-4 col-md">
            <h5>Discover</h5>
            <ul class="list-unstyled">
              <li>
                <router-link to="javascript:void(0)">FAQs</router-link>
              </li>
              <li>
                <router-link to="/blog">Our Blog</router-link>
              </li>
              <li>
                <router-link to="javascript:void(0)">Careers</router-link>
              </li>
              <li>
                <router-link to="javascript:void(0)">Contact us</router-link>
              </li>
              <li>
                <router-link to="javascript:void(0)"
                  >Media Resources</router-link
                >
              </li>
              <li>
                <router-link to="javascript:void(0)"
                  >Brand Resources</router-link
                >
              </li>
              <li>
                <router-link to="javascript:void(0)"
                  >Assets Library</router-link
                >
              </li>
              <li>
                <router-link to="/marketinsights">Market Insight</router-link>
              </li>
            </ul>
          </div>
          <div class="col-xs-12 col-sm-6 col-md">
            <h5>Coming Soon</h5>
            <p>
              Experience the B2B market place, Aggregator, Inventory Manager,
              and many other features on our app
            </p>
            <p>
              <img
                src="/assets/images/apple-app-store-icon_1x.png"
                class="img-fluid my-1 ml-sm-2 ml-md-0"
              />
              <img
                src="/assets/images/Google_play_1x.png"
                class="img-fluid my-1"
              />
            </p>
          </div>
          <div
            class="col-xs-12 col-sm-6 col-md text-left text-sm-center text-md-left px-4 mt-3"
          >
            <h6 class="text-sm-center text-md-left">
              We’ll love to keep you posted
            </h6>
            <p class="text-sm-center text-md-left">
              We’ll only send you relevant updates and stories you’ll love.
            </p>
            <div class="form-group">
              <input
                type="text"
                name="newsletter"
                class="form-control form-rounded form-big my-2"
                placeholder="Enter Email"
              />
              <button
                class="btn btn-pill btn-black text-sm-center text-md-left"
              >
                Subscribe
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- End Footer Content -->
    </section>

    <section class="copyright mb-5 pb-5 mb-md-0 pb-lg-5 position-relative">
      <div class="container">
        <div
          class="row text-center align-items-center d-sm-flex flex-sm-column-reverse"
        >
          <div class="col flex-grow-1">
            Copyright © 2020 Quick Leap. All rights reserved.
          </div>
          <div class="d-flex position-absolute align-items-center futa">
            <button class="btn btn-black btn-sm btn-pill mx-2">
              Chat with us on Whatsapp
            </button>
            <a
              class="d-inline-block mx-3"
              style="color: black"
              href="javascript::void(0)"
            >
              <font-awesome-icon :icon="['fas', 'comment-dots']" size="2x" />
            </a>
          </div>
        </div>
      </div>
    </section>
  </footer>
</template>

<script>
import PartnerCarousel from "@/components/PartnerCarousel";
import FooterTopCarousel from "@/components/FooterTopCarousel";
export default {
  components: {
    PartnerCarousel,
    FooterTopCarousel
  }
};
</script>

<style scoped>
footer {
  background: #fcfcfc;
}

.footer a {
  display: block;
  margin: 2px 0;
  text-decoration: none;
  color: black;
}

.footer a:hover {
  color: #507a1c;
  text-decoration: underline;
}

.social-icons a {
  border: 2px solid black;
  padding: 5px 0;
  border-radius: 5px;
  font-size: 13px;
  width: 50px;
}
</style>
